/**
 * Created by roman.kupin on 10/3/2017.
 */

import * as BigPictureActions from "../actions/index";

export default function bigPictureReducer(state = {
    isInitialized: false,
    startDate: null,
    endDate: null
}, {type, payload}) {

    switch (type) {
        case BigPictureActions.INITIALIZED: {
            return Object.assign({}, state, {isInitialized: payload});
        }
        case BigPictureActions.DATE_RANGE_CHANGE: {
            return Object.assign({}, state, {startDate: payload.startDate, endDate: payload.endDate});
        }
        default: {
            return state;
        }
    }
}